export default class TypeWriterText {
    constructor(options) {
        this.targetElement = options.targetElement; // タイピング対象の要素
        this.classesToAdd = options.classesToAdd; // 適用するクラス
        this.typingSpeed = options.typingSpeed || 200; // タイピングスピード（デフォルトは200ms）
        this.tagType = options.tagType || 'span'; // タグタイプ（デフォルトはspan）
        this.init(); // 初期化
    }

    init() {
        this.setupTypeWriter(this.targetElement);
    }

	// タイピングアニメーションの設定
    setupTypeWriter(element) {
        if (!this.classesToAdd) return; // クラスがなければ終了
        const classList = this.classesToAdd.split(' '); // クラスを配列に変換
        const text = element.textContent; // テキストを取得
        element.textContent = ''; // テキストを初期化

		// 文字を追加する関数
        const addCharacter = (index) => {
            if (index < text.length) { // テキストの長さ分だけ繰り返す
                const characterElement = document.createElement(this.tagType); // タグを生成
                characterElement.textContent = text.charAt(index); // テキストを1文字ずつ追加
                characterElement.className = classList[index % classList.length]; // クラスを追加
                element.appendChild(characterElement); // 要素に追加

                if (index + 1 < text.length) { // テキストの長さ分だけ繰り返す
                    setTimeout(() => {
                        requestAnimationFrame(() => addCharacter(index + 1)); // 次の文字を追加
                    }, this.typingSpeed); // タイピングスピードを設定
                }
            }
        };
        requestAnimationFrame(() => addCharacter(0)); // 文字を追加
    }
}